import React from 'react';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import useStyles from './styles';

export default function ResetButton({
  setInputDataToSend,
  setPostsList,
  setAccessoryList,
  setCornerAccessoryList,
  setCornerPostsList,
  setCornerPostAccessoryList,
  setNecessaryProductsQuantity,
}) {
  const classes = useStyles();

  const resetFetched = () => {
    setPostsList({});
    setAccessoryList({});
    setCornerPostsList({});
    setCornerPostAccessoryList({});
    setCornerAccessoryList({});
  };

  const resetInput = () => {
    setInputDataToSend('all', {});
  };

  const resetResults = () => {
    setNecessaryProductsQuantity({});
  };

  const handleResetButtonClick = () => {
    resetInput();
    resetFetched();
    resetResults();
  };

  return (
    <Button
      className={classes.buttonReset}
      variant="contained"
      color="secondary"
      onClick={handleResetButtonClick}
    >
      Reset
    </Button>
  );
}

ResetButton.propTypes = {
  setInputDataToSend: PropTypes.func.isRequired,
  setPostsList: PropTypes.func.isRequired,
  setAccessoryList: PropTypes.func.isRequired,
  setCornerPostsList: PropTypes.func.isRequired,
  setCornerAccessoryList: PropTypes.func.isRequired,
  setCornerPostAccessoryList: PropTypes.func.isRequired,
  setNecessaryProductsQuantity: PropTypes.func.isRequired,
};
